module.exports = __webpack_public_path__ + "static/media/plus.fa1aba10.svg";